import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  svngsPageTitle: 'Savings Calculator',
  svngsStep1Title: 'What volume of payments do you transact per month? (USD)',
  svngsStep2Title: 'How many suppliers do you pay per month?',
  svngsStep3Title:
    'How many people process payments and invoices for your suppliers?',
  svngsSelect: 'Select',
  svngsAction: 'Calculate savings',
  svngsResultTitle: 'Your potential savings on EFEX are:',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const SAVINGS_EXPORTER_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    svngsPageTitle: 'Calculadora de Ahorros',
    svngsStep1Title: '¿Qué volumen de pagos transaccionas al mes? (USD)',
    svngsStep2Title: '¿Cuántos proveedores pagas al mes?',
    svngsStep3Title:
      '¿Cuántas personas procesan los pagos y las facturas para tus proveedores?',
    svngsSelect: 'Seleccionar',
    svngsAction: 'Calcular ahorro',
    svngsResultTitle: 'Tu potencial ahorro en EFEX es de:',
  },
};

export default SAVINGS_EXPORTER_LABELS;
